import { UIGroup } from "./UIGroup";
import { Radio } from "./Radio";
export class RadioGroup extends UIGroup {
    constructor() {
        super();
        this._fitContent = true;
    }
    createItem(skin, label) {
        let btn = new Radio();
        btn._skinBaseUrl = this._skinBaseUrl;
        if (skin)
            btn.skin = skin;
        btn.label = label;
        if (!this._fitContent) {
            if (this._labelFixedSize.x > 0)
                btn.width = this._labelFixedSize.x;
            if (this._labelFixedSize.y > 0)
                btn.height = this._labelFixedSize.y;
        }
        return btn;
    }
    get fitContent() {
        return this._fitContent;
    }
    set fitContent(value) {
        if (this._fitContent != value) {
            this._fitContent = value;
            this._setLabelChanged();
        }
    }
    get labelFixedSize() {
        return this._labelFixedSize;
    }
    set labelFixedSize(value) {
        this._labelFixedSize = value;
        this._setLabelChanged();
    }
}
